
<template>
    <div class="focus-total-wrap">
        <h1 class="focus-pics-title" v-if="tag">{{tag}}</h1>
        <section class="focus-wrap module-wrap" :id="target" v-if="has_data" :data-spm="spm">
            <swipe :auto="3000" @change="onSlide">
                <template v-for="(item, index) in focus_list">
                    <swipe-item :key="index">
                        <a :href="item.link ? item.link : 'javascript:;'" :data-log-content-ev="item.stat_flag" @click.prevent="clickItemHandler(index)" ref="pics">
                            <div class="focus_item" :style="focus_img(item.picUrl)">
                                <footer class="info">
                                    <h3 class="tt">{{item.title}}</h3>
                                </footer>
                            </div>
                        </a>
                    </swipe-item>
                </template>
            </swipe>
        </section>
    </div>
</template>
<script>
import Swipe from './swiper/index';
import SwipeItem from './swiper/item';
import Util from '../_utils/util';
import nativeUtil from '../_utils/native-util.js'

export default {
    props: {
        target: {
            default: '',
            type: String
        },
        spm:{
            default: '',
            type: String
        },
        data: {
            type: Array,
            default: []
        },
        findex: {
            default: '',
            type: [String, Number]
        },
        tag: {
            default: '',
            type: String,
        }
    },
    methods: {
        focus_img(url){
            return `background-image:url('${url}')`;
        },
        onSlide(index){
            this.$emit('focus_slide', index);
        },
        clickItemHandler(index) {
            const pics = this.$refs.pics
            const url = pics[index].getAttribute('href')
            nativeUtil.openContent(url, this.focus_list[index])
        }
    },
    mounted(){
        this.$nextTick(() => {
            let focusList, container = document.getElementById(this.target);
            if(container){
                focusList = container.querySelectorAll('a[data-log-content-ev]');
                this.$emit('mounted', focusList);
            }
        })
    },
    computed: {
        focus_list(){
            let subId = window.subData.id;
            let flag_index = this.findex;
            let item, stat_flag = '', jump_link;
            this.data.forEach(function(item, index){
                stat_flag = `m-${subId}_subfocus_${flag_index}_${index + 1}`;
                item.stat_flag = stat_flag;
                jump_link = item.link || `/a/${item.articleId}_${item.authId}`;
                item.link = item.link ? Util.addQueryArgs(jump_link, {
                    _f: stat_flag
                }): null;
                item.picUrl = item.picUrl || item.imageUrl;
            });
            return this.data;
        },
        has_data(){
            return this.data.length > 0;
        }
    },
    components: {
        Swipe,
        SwipeItem
    },
}
</script>
<style lang="less">
.focus-total-wrap {
    padding-top: 6px;
    margin-bottom: 10px;
    .focus-pics-title {
        margin: 0 0 10px 11px;
        font-size: 17px; /*no*/
        font-weight: bold;
        color: #222222;
    }
    .focus-wrap{
        height: 188px;
        .mint-swipe .mint-swipe-indicators{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 10px;
            .mint-swipe-indicator{
                width: 6px;/*no*/
                height: 2px;/*no*/
                margin: 0 2px;/*no*/
                opacity: 0.6;
                background:#515355;
                border-radius: 5px;/*no*/
                &.is-active{
                    background-color: #fdd000;
                    opacity: 1;
                }
            }
        }
        
    }
    .focus_item{
        position: relative;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        background-image: url('../assets/images/preload.png');
        .info{
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 60px;
            background-color: red;
            background: linear-gradient(rgba(0, 0, 0, 0), rgba(57, 57, 57, 0.85));
            .tt{
                position: absolute;
                width: 100%;
                box-sizing: border-box;
                bottom: 18px;
                font-size: 18px;/*no*/
                line-height: 1.2em;
                font-weight: bold;
                padding-left: 13px;
                padding-right: 13px;
                color: #fff;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Focus.vue